module.exports = __webpack_public_path__ + "img/yuandianjiaofeng2.f243cd28.jpg";